import React, {useEffect, useState} from 'react';
import {withStyles} from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';

const LargerLinearProgress = withStyles(theme => ({
    root: {
        height: 10,
        borderRadius: 5,
    },
    colorPrimary: {
        backgroundColor:
            theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
    },
    bar: {
        borderRadius: 5,
        backgroundColor: '#1a90ff',
    },
}))(LinearProgress);

const LinearDeterminate = ({duration = 5000}) => {
    const [progress, setProgress] = useState(0);
    const refresh = 300;

    useEffect(() => {
        const timer = setInterval(() => {
            if (progress !== 100) {
                setProgress(oldProgress => {
                    const diff = (100 * refresh) / duration;
                    return Math.min(oldProgress + diff, 100);
                });
            }
        }, 300);

        return () => {
            clearInterval(timer);
        };
    }, [duration, progress]);

    return (
        <div style={{width: '100%'}}>
            <LargerLinearProgress variant='determinate' value={progress} />
        </div>
    );
};

export default LinearDeterminate;
export {LinearDeterminate, LargerLinearProgress};
